/**
 * StageBadge — compact pill showing the current Verify Hub stage for a single
 * applicant or household. Used in list rows + queue tables so PMs/Staff can
 * read status without opening the record.
 *
 * Pass either:
 *   - <StageBadge screening={s} />
 *   - <StageBadge group={g} />
 *   - <StageBadge stageKey="ready" />
 */
import {
  PIPELINE_STAGES,
  PIPELINE_DOT,
  PIPELINE_PILL,
  stageFor,
  householdStageFor,
} from "@/lib/verifyHub";

export default function StageBadge({
  screening,
  group,
  stageKey,
  size = "sm",       // 'xs' | 'sm' | 'md'
  showIcon = true,
  className = "",
  testid,
}) {
  const stage = stageKey
    ? PIPELINE_STAGES.find((s) => s.key === stageKey) || PIPELINE_STAGES[0]
    : group
      ? householdStageFor(group)
      : stageFor(screening);

  const Icon = stage.icon;
  const sizeCls =
    size === "xs"
      ? "text-[9px] px-1.5 py-0.5 gap-1"
      : size === "md"
        ? "text-xs px-2.5 py-1 gap-1.5"
        : "text-[10px] px-2 py-0.5 gap-1";

  return (
    <span
      className={`inline-flex items-center font-semibold uppercase tracking-wider rounded-full ${sizeCls} ${PIPELINE_PILL[stage.tone]} ${className}`}
      data-testid={testid || `stage-badge-${stage.key}`}
      title={stage.label}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${PIPELINE_DOT[stage.tone]}`} />
      {showIcon && <Icon className="h-3 w-3" strokeWidth={2} />}
      <span className="truncate">{stage.label}</span>
    </span>
  );
}
